angular.module( 'acme.view.application.modals.dedupe', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.modals.dedupe.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var dedupeModal = {
        name: 'application.modals.dedupe',
        url: '/modals/dedupe',
        views: {
          "main": {
            controller: 'dedupeModalController',
            // Assumes the view is entirely self contained
            templateUrl: 'common/views/modals/dedupe/dedupe.tpl.html'
          }
        },
        data: {
          pageTitle: '  ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(dedupeModal);
});
